export default __webpack_public_path__ + "static/media/pagePhoto3.55fe2283.png";